import apiClient from '../api.js';

// Búsqueda de estudiantes del BuscadorModal (endpoints legacy de /estudiante).
//
//   GET /estudiante/buscarestapell33/:paterno,:materno,:nombres,:id_sede
//       (cada término vacío va como "XXX", así lo espera la función almacenada)
//   GET /estudiante/buscaestunicodigoinsc/:unicodigo,:id_sede
//       -> { resultado: [ { unicod, matr, pat, mat, nom, carre, ... } ] | null,
//            message }
//
//   `resultado: null` = sin coincidencias (no es un error). Los errores de
//   estos endpoints legacy traen el texto en `.message`, no en `.mensaje`.

const resource = '/estudiante';

const termino = (valor) => (valor ? valor : 'XXX');

const useEstudianteBusquedaApi = {
  buscarPorApellidos({ paterno, materno, nombres, id_sede }) {
    return apiClient.get(
      `${resource}/buscarestapell33/${termino(paterno)},${termino(materno)},${termino(nombres)},${id_sede}`,
    );
  },
  buscarPorUnicodigo({ unicodigo, id_sede }) {
    return apiClient.get(`${resource}/buscaestunicodigoinsc/${unicodigo},${id_sede}`);
  },
};

export default useEstudianteBusquedaApi;
